import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController,IonRouterOutlet } from '@ionic/angular';
@Component({
  selector: 'app-receiver',
  templateUrl: './receiver.page.html',
  styleUrls: ['./receiver.page.scss'],
})
export class ReceiverPage implements OnInit {
  amount:any;
  cangoback:boolean = false;
  constructor(private navCtrl:NavController,private outlet: IonRouterOutlet,private route: ActivatedRoute) { 
    this.amount = this.route.snapshot.paramMap.get('amount').replace(/,/g,'');
  }

  close(){
    if(this.cangoback) this.navCtrl.pop()
    else this.navCtrl.navigateBack('/'); 
  }

  ngOnInit() {
    this.cangoback = this.outlet && this.outlet.canGoBack();
  }

}
